module.exports = __webpack_public_path__ + "static/media/Anchoring Effect.9c3034ad.jpg";